import { CONTENT } from '../content/runtime.js';

export const CONTENT_HASH = CONTENT.contentHash;
export const GAME_VERSION = `sky-harbor-v6-${CONTENT_HASH}`;
